import React from 'react';
import ContentLoader from 'react-content-loader';
import times from 'lodash.times';

export default ListLoader;

function ListLoader(props: any): any {
  const {
    len,
    itemWidth = 130,
    itemHeight = 16,
    itemMargin = 8,
    ...rest
  } = props;

  return (
    <ContentLoader
      width={itemWidth}
      height={len * (itemHeight + itemMargin)}
      uniquekey={'list-loader'}
      {...rest}
    >
      {times(len, (i) => (
        <rect
          key={i}
          width={itemWidth}
          height={itemHeight}
          x="0"
          y={i * (itemHeight + itemMargin)}
        />
      ))}
    </ContentLoader>
  );
}
